import { UIText3 } from '@cian/ui-kit';
import { IconActionMore16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardMenuControlProps = {
  onClick(): void;
};

export const UserCardMenuControl: React.FC<TUserCardMenuControlProps> = ({ onClick }) => {
  return (
    <button type="button" onClick={onClick} className={styles['button']} data-testid="UserCardMenuControl">
      <IconActionMore16 color="icon-main-default" height={24} />
      <UIText3 color="text-main-default">Еще</UIText3>
    </button>
  );
};
